import WithAuth from "../components/hoc/with-auth"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import MostProfitablePage from "../components/pages/most-profitable"

const MostProfitable = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Most Profitable Trades"
          pageDesc="List of all the most profitable trades"
        >
          <MostProfitablePage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default MostProfitable
